export const HEADER_LOGO = "HEADER_LOGO";
export const PAY_NOW = "PAY_NOW";
export const SHOW_BATCH_TABLE = "SHOW_BATCH_TABLE";
export const HEADER_LOGO_IN_BASE = "HEADER_LOGO_IN_BASE";
export const PAYALLVALUE = "PAYALLVALUE";
export const PAYALLNOWVALUE = "PAYALLNOWVALUE";
export const HIDE_PAYMENT_BUTTON = "HIDE_PAYMENT_BUTTON";
